import React, { useState } from 'react';

import { View } from '@rbilabs/universal-components';
import { Image } from 'expo-image';
import { useIntl } from 'react-intl';
import { spacing } from 'ucl/themes/shared/primitives';

import { IServerOrder } from '@rbi-ctg/menu';
import { useAppTakeoverOrderConfirmDetails } from 'components/app-takeover/use-app-takeover-cart';
import useOrderNumber from 'hooks/use-order-number';
import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { Container, Header, Instructions, OrderNumber } from './styled';
import { getOrderConfirmationHeader, getOrderConfirmationInstructions } from './utils';

interface IOrderConfirmationHeader {
  serverOrder: IServerOrder;
}
const OrderConfirmationHeader = ({ serverOrder }: IOrderConfirmationHeader) => {
  const { user } = useAuthContext();
  const { formatMessage } = useIntl();
  const orderNumber = useOrderNumber(serverOrder);
  const isMobileOrderForDriveThruLaneEnabled = useFlag(
    LaunchDarklyFlag.ENABLE_MOBILE_ORDER_DRIVE_THRU_LANE
  );
  const formatedOrderNumber = formatMessage({ id: 'orderConfirmationNumber' }, { orderNumber });
  const serviceMode = serverOrder.cart.serviceMode;
  const userName = (user?.details.name ?? '').split(' ')[0];

  const {
    headerImage: takeoverImage,
    headerFontColor: takeoverFontColor,
    headerBackgroundColor: backgroundColor,
  } = useAppTakeoverOrderConfirmDetails(serverOrder?.rbiOrderId);

  const headerText = getOrderConfirmationHeader({ userName, formatMessage });
  const instructions = getOrderConfirmationInstructions({
    userName,
    serviceMode,
    formatMessage,
    isMobileOrderForDriveThruLaneEnabled,
  });

  const [ratio, setRatio] = useState(16 / 9);

  return (
    <Container
      style={{
        marginHorizontal: spacing.$4 * -1,
        marginTop: spacing.$4 * -1,
      }}
    >
      <View
        style={{
          backgroundColor,
          paddingTop: spacing.$4,
          paddingHorizontal: spacing.$4,
        }}
      >
        {orderNumber && (
          <OrderNumber focusable color={takeoverFontColor}>
            {formatedOrderNumber}
          </OrderNumber>
        )}
        {!!headerText && !!userName && (
          <Header focusable color={takeoverFontColor}>
            {headerText}
          </Header>
        )}
        <Instructions focusable color={takeoverFontColor}>
          {instructions}
        </Instructions>
      </View>
      {takeoverImage && (
        <Image
          source={takeoverImage}
          style={{ width: '100%', aspectRatio: ratio }}
          contentFit="cover"
          onLoad={e => {
            const { width, height } = e.source || {};
            if (width && height) {
              setRatio(width / height);
            }
          }}
        />
      )}
    </Container>
  );
};

export default OrderConfirmationHeader;
